import { BattleType } from "../../../types/BattleType";
import { ContestantTargetType } from "../../../types/ContestantTargetType";
import { ContestantType } from "../../../types/ContestantType";
import { TargetType } from "../../../types/TargetType";
import dayjs from "dayjs";

export const getGroupBattleScores = (battle: BattleType, setGroupBattleScores: any) => {
  const daysResult: Record<string, { contestant: ContestantType, score: number }> = {};
  for (const contestant of battle.contestants) {
    daysResult[contestant.id] = { contestant, score: 0 };
  }

  const days = battle.days;

  for (const day of days) {
    if (dayjs(day.date).isSame(dayjs(), "day") || dayjs(day.date).isAfter(dayjs(), "day")) continue;
    const dayResult: Record<string, { contestant: ContestantType, score: number }> = {};
    for (const contestant of battle.contestants) {
      dayResult[contestant.id] = { contestant, score: 0 };
    }


    const targets: TargetType[] = day.targets;
    for (const target of targets) {
      for (const e in target) {
        if (typeof target[e] !== "object") continue;
        const contestantTarget: ContestantTargetType = target[e];
        if (typeof contestantTarget !== "object") continue;
        if (target.isPhotoRequired && contestantTarget.photo && contestantTarget.input) {
          const id = contestantTarget.userId;
          dayResult[id] = { ...dayResult[id], score: dayResult[id].score + 1 };
        }
        if (!target.isPhotoRequired && contestantTarget.input) {
          const id = contestantTarget.userId;
          dayResult[id] = { ...dayResult[id], score: dayResult[id].score + 1 };
        }
      }
    }

    let resultArray: any = [];
    let topScore = 0;
    for (const e in dayResult) {
      const contestant = dayResult[e];
      if (contestant.score > topScore) {
        resultArray = [contestant.contestant];
        topScore = contestant.score;
      }
      else if (contestant.score === topScore) {
        resultArray.push(contestant.contestant);
      }
    }

    for (const contestant of resultArray) {
      daysResult[contestant.id] = { ...daysResult[contestant.id], score: daysResult[contestant.id].score + 1 };
    }
  }

  setGroupBattleScores(daysResult);
}

export function getGroupWinnerIds(battle: BattleType) {
  return battle.result.winners?.map((winner: any) => winner.id) || [];
}